import routerOptions0 from "/builds/lottocom/shop-frontend/frontend/node_modules/.pnpm/nuxt@3.16.2_patch_hash=5def9818cff2516e81c501b8f21bf66204ee2fca4271d1455d96717793a6460d_4d760d5dad13aef599d01862b72aa95b/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/lottocom/shop-frontend/frontend/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}